import React, { useState, useEffect } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

const AdvancedFilters = ({
                             filtros,
                             setFiltros,
                             rangoPrecio,
                             filtroLocalizacion,
                             onAplicar
                         }) => {
    const minPrecio = Number(rangoPrecio.min) || 0;
    const maxPrecio = Number(rangoPrecio.max) || 1000000;

    const [localFiltros, setLocalFiltros] = useState({ ...filtros });
    const [sliderValue, setSliderValue] = useState([
        Number(filtros.precioMin) || minPrecio,
        Number(filtros.precioMax) || maxPrecio
    ]);

    useEffect(() => {
        setLocalFiltros({ ...filtros });
        setSliderValue([
            Number(filtros.precioMin) || minPrecio,
            Number(filtros.precioMax) || maxPrecio
        ]);
    }, [JSON.stringify(filtros), minPrecio, maxPrecio]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setLocalFiltros((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const handleSliderChange = ([min, max]) => {
        setSliderValue([min, max]);
        setLocalFiltros(prev => ({
            ...prev,
            precioMin: min,
            precioMax: max
        }));
    };

    const aplicar = () => {
        setFiltros({ ...localFiltros });

        if (onAplicar) {
            onAplicar({
                ...localFiltros,
                localizaciones: filtroLocalizacion
            });
        }
    };

    const superficieOptions = Array.from({ length: 8 }, (_, i) => i * 50 + 50);
    const habitacionesOptions = [1, 2, 3, 4, 5];
    const banosOptions = [1, 2, 3, 4, 5];

    return (
        <div className="bg-white border border-gray-200 p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Precio */}
                <div className="col-span-1 md:col-span-2">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">💶 Precio (€)</label>
                    <Slider
                        range
                        min={minPrecio}
                        max={maxPrecio}
                        value={sliderValue}
                        onChange={handleSliderChange}
                        trackStyle={[{ backgroundColor: "#3B82F6" }]}
                        handleStyle={[{ borderColor: "#3B82F6" }, { borderColor: "#3B82F6" }]}
                    />
                    <div className="flex space-x-2 mt-3">
                        <input
                            type="number"
                            name="precioMin"
                            value={localFiltros.precioMin}
                            onChange={handleChange}
                            placeholder="Mínimo"
                            className="w-1/2 px-3 py-2 border rounded text-sm"
                        />
                        <input
                            type="number"
                            name="precioMax"
                            value={localFiltros.precioMax}
                            onChange={handleChange}
                            placeholder="Máximo"
                            className="w-1/2 px-3 py-2 border rounded text-sm"
                        />
                    </div>
                </div>

                {/* Superficie */}
                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">📐 Superficie mínima (m²)</label>
                    <select
                        name="superficieMin"
                        value={localFiltros.superficieMin}
                        onChange={handleChange}
                        className="border rounded px-3 py-2 w-full"
                    >
                        <option value="">Sin mínimo</option>
                        {superficieOptions.map((val) => (
                            <option key={val} value={val}>{val} m²</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">📐 Superficie máxima (m²)</label>
                    <select
                        name="superficieMax"
                        value={localFiltros.superficieMax}
                        onChange={handleChange}
                        className="border rounded px-3 py-2 w-full"
                    >
                        <option value="">Sin máximo</option>
                        {superficieOptions.map((val) => (
                            <option key={val} value={val}>{val < 400 ? val + ' m²' : '400+ m²'}</option>
                        ))}
                    </select>
                </div>

                {/* Habitaciones */}
                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">🛏️ Habitaciones mínimas</label>
                    <select
                        name="habitacionesMin"
                        value={localFiltros.habitacionesMin}
                        onChange={handleChange}
                        className="border rounded px-3 py-2 w-full"
                    >
                        <option value="">Sin mínimo</option>
                        {habitacionesOptions.map((val) => (
                            <option key={val} value={val}>{val}{val === 5 ? '+' : ''}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">🛏️ Habitaciones máximas</label>
                    <select
                        name="habitacionesMax"
                        value={localFiltros.habitacionesMax}
                        onChange={handleChange}
                        className="border rounded px-3 py-2 w-full"
                    >
                        <option value="">Sin máximo</option>
                        {habitacionesOptions.map((val) => (
                            <option key={val} value={val}>{val}{val === 5 ? '+' : ''}</option>
                        ))}
                    </select>
                </div>

                {/* Baños */}
                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">🛁 Baños mínimos</label>
                    <select
                        name="banosMin"
                        value={localFiltros.banosMin}
                        onChange={handleChange}
                        className="border rounded px-3 py-2 w-full"
                    >
                        <option value="">Sin mínimo</option>
                        {banosOptions.map((val) => (
                            <option key={val} value={val}>{val}{val === 5 ? '+' : ''}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">🛁 Baños máximos</label>
                    <select
                        name="banosMax"
                        value={localFiltros.banosMax}
                        onChange={handleChange}
                        className="border rounded px-3 py-2 w-full"
                    >
                        <option value="">Sin máximo</option>
                        {banosOptions.map((val) => (
                            <option key={val} value={val}>{val}{val === 5 ? '+' : ''}</option>
                        ))}
                    </select>
                </div>

                {/* Checkboxes */}
                <div className="md:col-span-2 space-y-2 mt-2">
                    <label className="flex items-center">
                        <input
                            type="checkbox"
                            name="soloIA"
                            checked={localFiltros.soloIA}
                            onChange={handleChange}
                            className="mr-2"
                        />
                        Mostrar solo propiedades con análisis IA
                    </label>
                    <label className="flex items-center">
                        <input
                            type="checkbox"
                            name="esAnalizable"
                            checked={localFiltros.esAnalizable}
                            onChange={handleChange}
                            className="mr-2"
                        />
                        Mostrar solo propiedades analizables por IA
                    </label>
                </div>
            </div>

            {/* Botón Aplicar */}
            <div className="mt-6 text-right">
                <button
                    onClick={aplicar}
                    className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 text-sm"
                >
                    Aplicar filtros
                </button>
            </div>
        </div>
    );
};

export default AdvancedFilters;
